<template>
  <div>
    <div v-title data-title="安丘专技教育-注册"></div>
    <phone-login-layout>
      <login-form-component type="register"></login-form-component>
    </phone-login-layout>
  </div>
</template>

<script>
import LoginFormComponent from '@/page/login/components/loginFormComponent';
import PhoneLoginLayout from '@/page/login/components/phoneLoginLayout';

export default {
  name: 'phoneRegister',
  components: {
    LoginFormComponent,
    PhoneLoginLayout
  }
};
</script>
